import { VisualizationEnum, EntityTypeEnum, DimensionEnum, LegendOptionEnum } from 'app/model/enum.model';
import { GraphData } from './../../../model/graph-data.model';
import { GraphConfig } from './../../../model/graph-config.model';

export class ScatterConfigModel extends GraphConfig {
  constructor() {
    super();
    this.enableGenesets = false;
    this.enableCohorts = false;
    this.enableSupplemental = false;
    this.legendOptions = [{
      type: LegendOptionEnum.MARKER_BASE_SIZE,
      enabled: true,
    },
    {
      type: LegendOptionEnum.MARKER_OPACITY,
      enabled: true,
    },
    {
      type: LegendOptionEnum.SHAPE,
      enabled: false
    },
    {
      type: LegendOptionEnum.COLOR,
      enabled: false
    }
  ]
    this.entity = EntityTypeEnum.SAMPLE;
    this.visualization = VisualizationEnum.SCATTER;
    this.label = 'Scatter';
  }
  uri = 'cell-scaled.json';
}

export interface ScatterDataModel extends GraphData {
  result: any;
  resultScaled: Array<Array<number>>;
  sid: Array<string>;
  mid: Array<string>;
  pid: Array<string>;
}
